import { Link } from "react-router-dom";
import AppHeader from "@/components/AppHeader";
import { Button } from "@/components/ui/button";
import { Boxes, Clock, ArrowRight, Hammer, Ruler, PackageCheck } from "lucide-react";

export default function Anaqueles() {
    return (
        <div className="min-h-screen bg-white">
            <AppHeader subtitle="Cotizador · Anaqueles" backTo="/" />
            <main className="max-w-[1400px] mx-auto px-6 py-10 lg:py-14">
                <div className="grid lg:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] gap-10 items-center">
                    <div>
                        <div className="text-[11px] font-mono uppercase tracking-[0.25em] text-slate-500 mb-4 flex items-center gap-2">
                            <Clock className="h-3.5 w-3.5 text-[#F59E0B]" />
                            Módulo en construcción
                        </div>
                        <h1 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-slate-900 leading-[1.05]">
                            Cotizador de <span className="text-[#1BA5D9]">Anaqueles</span>
                            <br />
                            próximamente.
                        </h1>
                        <p className="mt-5 text-slate-600 leading-relaxed max-w-xl">
                            Estamos afinando la matriz de precios, medidas y descuentos por volumen para el catálogo de anaqueles metálicos. Mientras tanto, el cotizador de <b>Unidosis Opus Pac</b> ya está listo para usarse.
                        </p>

                        <div className="mt-8 grid sm:grid-cols-3 gap-4 max-w-xl" data-testid="anaqueles-roadmap">
                            <RoadmapItem icon={<Ruler className="h-4 w-4" />} title="Configurador" text="Altura, ancho y entrepaños" />
                            <RoadmapItem icon={<Hammer className="h-4 w-4" />} title="Instalación" text="Cálculo por sitio" />
                            <RoadmapItem icon={<PackageCheck className="h-4 w-4" />} title="Descuentos" text="Por volumen y plazo" />
                        </div>

                        <div className="mt-10 flex flex-wrap gap-3">
                            <Link to="/unidosis">
                                <Button
                                    data-testid="anaqueles-goto-unidosis-btn"
                                    className="h-11 px-5 rounded-md bg-[#1BA5D9] hover:bg-[#0E7DAB] active:scale-[.99] transition-all duration-150"
                                >
                                    Ir al cotizador de Unidosis
                                    <ArrowRight className="h-4 w-4 ml-2" />
                                </Button>
                            </Link>
                            <Link to="/">
                                <Button
                                    variant="outline"
                                    className="h-11 px-5 rounded-md border-slate-200 hover:bg-slate-50"
                                    data-testid="anaqueles-goto-dashboard-btn"
                                >
                                    Volver al panel
                                </Button>
                            </Link>
                        </div>
                    </div>

                    <div className="relative rounded-md overflow-hidden border border-slate-200 aspect-[4/5]">
                        <div
                            className="absolute inset-0 bg-cover bg-center"
                            style={{
                                backgroundImage:
                                    "url(https://images.unsplash.com/photo-1580281657529-557a6abb6387?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80)",
                            }}
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/85 via-slate-900/40 to-transparent" />
                        <div className="absolute inset-0 bg-grid opacity-10 mix-blend-overlay" />
                        <div className="absolute bottom-6 left-6 right-6 text-white">
                            <div className="text-[11px] font-mono uppercase tracking-widest text-white/70 mb-1">
                                Catálogo previsto
                            </div>
                            <div className="font-heading text-2xl font-semibold tracking-tight">
                                Anaqueles metálicos <br /> para farmacia hospitalaria
                            </div>
                            <div className="mt-4 flex items-center gap-2">
                                <Boxes className="h-4 w-4" />
                                <span className="text-sm font-mono">Liviano · Mediano · Pesado</span>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

function RoadmapItem({ icon, title, text }) {
    return (
        <div className="border border-slate-200 rounded-md p-4 bg-slate-50/60">
            <div className="h-7 w-7 rounded-sm bg-white border border-slate-200 grid place-items-center text-[#1BA5D9]">
                {icon}
            </div>
            <div className="mt-3 font-medium text-sm text-slate-900">{title}</div>
            <div className="text-xs text-slate-500 mt-0.5">{text}</div>
        </div>
    );
}
